;(function() {
"use strict";

angular.module('kauffman-press-frontend.DashboardRequest', [
  'core.AbstractResource',
  'core.Backoff',
])
  .factory('Dashboard', DashboardFactory)
  .factory('DashboardRequest', DashboardRequestFactory);

DashboardFactory.$inject = ['$location', 'AbstractResource', 'MYSW_DOMAIN'];
function DashboardFactory($location, AbstractResource, MYSW_DOMAIN) {
  const proto = $location.protocol();
  const api_root = `${proto}://data.${MYSW_DOMAIN}/api/press/v1/`;
  const REQUEST_URL = `${api_root}dashboards/:request`;

  class Dashboard extends AbstractResource {
    constructor(props) {
      super(REQUEST_URL, { meta: { responseKey: 'dashboards', lookupField: 'request' } });
      this.initialize(props);
    }
  }

  return Dashboard;
}

DashboardRequestFactory.$inject = ['$location', '$q', 'AbstractResource', 'Backoff', 'MYSW_DOMAIN', 'Dashboard'];
function DashboardRequestFactory($location, $q, AbstractResource, Backoff, MYSW_DOMAIN, Dashboard) {
  const proto = $location.protocol();
  const api_root = `${proto}://data.${MYSW_DOMAIN}/api/press/v1/`;
  const REQUEST_URL = `${api_root}dashboard-requests/:id`;

  class DashboardRequest extends AbstractResource {
    constructor(props) {
      super(REQUEST_URL, { meta: { responseKey: 'dashboardRequests' } });
      this.initialize(props);
    }

    poll() {
      const deferred = $q.defer();
      const initialDelay = 2 * 1000;

      const backoff = new Backoff({ interval: initialDelay, maxAttempts: 15, factor: 1.1 });
      backoff.exec(() => {
        Dashboard.get(this.id).then((dashboard) => {
          if (dashboard) {
            deferred.resolve(dashboard.url);
          }
        }).catch(angular.noop);
      });

      const stop = backoff.stop.bind(backoff);
      deferred.promise.then(stop, stop);

      return deferred.promise;
    }

    static poll(...args) {
      return DashboardRequest
        .create(...args)
        .then((request) => {
          return request.poll();
        });
    }
  }

  return DashboardRequest;
}
}());
